export default __webpack_public_path__ + "media/easy-breezy3x.2d89dfee.png";